/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeDecisionForProjectPenaltyCommand } from '../../models/change-decision-for-project-penalty-command';
import { ChangeDecisionForProjectPenaltyCommandResult } from '../../models/change-decision-for-project-penalty-command-result';

export interface ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Params {
      body?: ChangeDecisionForProjectPenaltyCommand
}

export function apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>;
    })
  );
}

apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain.PATH = '/api/ProjectPenalties/ChangeDecisionForProjectPenalty';
